(() => {
  const cache = new Map();

  const giftWrapId = () => {
    const gw = document.querySelector('gift-wrap');
    return gw ? parseInt(gw.dataset.variantId, 10) : null;
  };

  const getVariants = async handle => {
    if (cache.has(handle)) return cache.get(handle);
    try {
      const p = await (await fetch(`/products/${handle}.js`)).json();
      cache.set(handle, p.variants);
      return p.variants;
    } catch (e) {
      console.error('cart-variant-switcher: failed to load variants for', handle, e);
      return null;
    }
  };

  const getSections = () =>
    document.querySelector('cart-items, cart-drawer-items')?.getSectionsToRender?.() || [];

  const refresh = async () => {
    const sections = getSections();
    if (!sections.length) { location.reload(); return; }
    try {
      const url = `${location.pathname}?sections=${sections.map(s => s.section).join(',')}`;
      const data = await (await fetch(url)).json();
      sections.forEach(s => {
        const el = document.querySelector(s.selector) || document.querySelector(s.id);
        if (el && data[s.section]) {
          el.innerHTML = new DOMParser()
            .parseFromString(data[s.section], 'text/html')
            .querySelector(s.selector).innerHTML;
        }
      });
      if (typeof window.updateCartCounters === 'function') window.updateCartCounters();
      if (typeof window.updateFreeShipping === 'function') window.updateFreeShipping();
      if (typeof window.handleCartInputNames === 'function') window.handleCartInputNames();
      build();
    } catch (e) {
      console.error('cart-variant-switcher: refresh failed', e);
      location.reload();
    }
  };

  const swap = async (oldId, newId, qty, select) => {
    const container = document.querySelector('cart-items, cart-drawer-items');
    container?.classList.add('is-loading');
    select.disabled = true;
    try {
      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: newId, quantity: qty }] })
      });
      if (!addRes.ok) throw new Error('add: ' + await addRes.text());

      const cart = await (await fetch('/cart.js')).json();
      const oldLine = cart.items.findIndex(i => i.variant_id === oldId) + 1;
      if (oldLine > 0) {
        const chRes = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: oldLine, quantity: 0 })
        });
        if (!chRes.ok) throw new Error('change: ' + await chRes.text());
      }

      await refresh();
    } catch (e) {
      console.error('cart-variant-switcher: swap failed', e);
      alert('Could not change the variant. Please try again.');
      select.disabled = false;
    } finally {
      container?.classList.remove('is-loading');
    }
  };

  const buildSelect = async item => {
    if (item.querySelector('gift-wrap')) return;
    const link = item.querySelector('a[href*="/products/"]');
    if (!link) return;

    let url;
    try { url = new URL(link.href, location.origin); } catch { return; }
    const handle = url.pathname.split('/products/')[1]?.split('?')[0];
    const currentVariant = parseInt(url.searchParams.get('variant'), 10);
    if (!handle || !currentVariant || currentVariant === giftWrapId()) return;

    const qtyWrap = item.querySelector('.cart-item__quantity');
    if (!qtyWrap || qtyWrap.dataset.variantSelect) return;
    qtyWrap.dataset.variantSelect = '1';

    const variants = await getVariants(handle);
    if (!variants || variants.length < 2) {
      delete qtyWrap.dataset.variantSelect;
      return;
    }

    item.querySelectorAll('.cart-item__content > dl:not(.cart-item__properties)').forEach(dl => dl.remove());

    const select = document.createElement('select');
    select.className = 'cart-variant-select';
    select.setAttribute('aria-label', 'Change variant');
    variants.forEach(v => {
      const opt = document.createElement('option');
      opt.value = v.id;
      opt.textContent = v.available ? v.title : `${v.title} — sold out`;
      if (!v.available) opt.disabled = true;
      if (v.id === currentVariant) opt.selected = true;
      select.appendChild(opt);
    });

    const qty = parseInt(item.querySelector('[name="updates[]"]')?.value || '1', 10);

    select.addEventListener('change', () => {
      const newId = parseInt(select.value, 10);
      if (newId === currentVariant) return;
      swap(currentVariant, newId, qty, select);
    });

    qtyWrap.classList.add('cart-item__quantity--has-variant');
    qtyWrap.insertBefore(select, qtyWrap.firstChild);
  };

  const build = () => document.querySelectorAll('.cart-item').forEach(buildSelect);

  const observe = () => {
    const targets = [
      document.querySelector('#CartDrawer-Body'),
      document.querySelector('#main-cart-items'),
      document.querySelector('cart-drawer'),
      document.querySelector('cart-items')
    ].filter(Boolean);

    if (!targets.length) return;

    const obs = new MutationObserver(() => build());
    targets.forEach(t => obs.observe(t, { childList: true, subtree: true }));
  };

  const init = () => {
    build();
    observe();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();